import * as React from 'react';
import '@styles/pages/tab1.scss';
import { StageDefault, StageCurrent } from '@/context.ts';
import { fetch, AreaInfo, RankItem } from '@/fetch.ts';
import RankHeader from '@hook/public/rankHeader.tsx';
import Page from '@hook/public/page.tsx';
import AnchorItem from '@hook/public/anchorItem.tsx';
import NoneData from '@hook/public/none.tsx';
interface Props extends AreaInfo{
  readonly revive: boolean,
  readonly haixuan: boolean,
}
const { useState, useEffect, useContext } = React;

const Tab1Rank: React.FC<Props> = props => {
  const {tabCurrent, iStage} = useContext(StageDefault);
  const {current} = useContext(StageCurrent);

  const [list, List] = useState<RankItem[]>([]);
  const [showList, ShowList] = useState<RankItem[]>([]);
  const [pageShow, PageShow] = useState<boolean>(true);
  const [iPromoteNum, IPromoteNum] = useState<number>(0);
  const pageChange = (index: number): void => {
    ShowList(list.slice((index) * 10, (index + 1) * 10 >= list.length ? list.length : (index + 1) * 10));
  }
  useEffect(() => {
    PageShow(false);
    /* 获取分区榜单 */
    fetch.getStageRank(
      {
        iMatchId: tabCurrent,
        iStage: current,
        iArea: props.iArea,
        iRevive: props.revive ? 1 : 0,
        lPid: 0,
      },
    )
      .then(rsp => {
        PageShow(true);
        List(rsp.vRank.value.slice(0, 50));
        ShowList(rsp.vRank.value.length > 10 ? rsp.vRank.value.slice(0, 10) : rsp.vRank.value);
        IPromoteNum(rsp.iPromoteNum);
      })
  }, [current, tabCurrent, props.revive, props.haixuan])
  return (
    <div className='tab1Rank' id={'area' + props.iArea}>
      <h1>{props.sName}</h1>
      <RankHeader
        width={300}
        color='#519ff7'
        prev='排名'
        mid='主播昵称'
        next={props.revive ? '复活热度' : '热度'}
      />
      <div className='tab1RankList'>
        {
          showList.length === 0 ?
            <NoneData text={'暂无数据'} />
            :
            showList.map((item: RankItem) => {
              if (item.iRank === iPromoteNum && props.haixuan) {
                return (
                  <React.Fragment
                    key={item.lUid}
                  >
                    <AnchorItem
                      width={306}
                      {...item}
                      revive={props.revive}
                      chamption={false}
                    />
                    <div className='haixuanLabel'>分区前{iPromoteNum}晋级下一阶段</div>
                  </React.Fragment>
                )
              }
              return (
                <AnchorItem
                  key={item.lUid}
                  width={306}
                  {...item}
                  revive={props.revive}
                  chamption={false}
                />
              )
            })
        }
      </div>
      {
        pageShow &&
        <Page
          pageLen={list.length % 10 === 0 ? list.length / 10 : Math.floor(list.length / 10) + 1}
          setPageIndex={pageChange}
        />
      }
    </div>
  )
}
export default Tab1Rank;